// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3NdcF","buttons":"SendReceipts_buttons__2npIv","email":"SendReceipts_email__25ir0","bookApptTitle":"SendReceipts_bookApptTitle__JOr2x"};